import type { AxiosResponse } from "axios"
import type { ServerResponse } from "@/http"
import type { IAlbumResponse } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { Album } from "@/models"

export async function createAlbum(eventVaultId: number, album: Album): Promise<Album> {
  const albumFields = new FormData()

  albumFields.append("title", album.title?.trim() ?? "")
  if (album.description)
    albumFields.append("description", album.description)
  if (album.date)
    albumFields.append("albumDate", album.date?.toDateString())
  if (album.coverImage)
    albumFields.append("coverImageFile", album.coverImage)
  if (album.passcode)
    albumFields.append("albumPasscode", album.passcode)
  if (album.isLocked)
    albumFields.append("isLocked", album.isLocked!.toString())
  if (album.isHidden)
    albumFields.append("isHidden", album.isHidden!.toString())
  if (album.location && album.location?.formattedAddress)
    albumFields.append("location", JSON.stringify(album.location))

  albumFields.append("AlbumSettings.DisableGuestUpload", (album.settings?.disableUploads ?? false).toString())
  albumFields.append("AlbumSettings.SharePixWithGuests", (album.settings?.sharePix ?? false).toString())

  const response: AxiosResponse<ServerResponse<IAlbumResponse>> = await axios.post(
    `api/event/${eventVaultId}/album`,
    albumFields,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  )

  return Album.fromResponse(response.data.Data)
}

export function useCreateAlbum() {
  return useMutation({
    mutationFn: ({ album, eventVaultId }: { album: Album, eventVaultId: number }) => createAlbum(eventVaultId, album),
  })
}
